<template>
  <!-- Modal backdrop -->
  <div
    v-if="isVisible"
    class="modal-backdrop fade show"
    @click="close"
  ></div>

  <!-- Modal -->
  <div
    class="modal fade"
    :class="{ show: isVisible }"
    :style="{ display: isVisible ? 'block' : 'none' }"
    tabindex="-1"
    :aria-hidden="!isVisible"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('plan_trail.route_usage_modal.route_usage') }}</h5>
          <button type="button" class="btn-close" @click="close" :aria-label="$t('shared.close')"></button>
        </div>
        <div class="modal-body">
          <i18n-t v-if="route" keypath="plan_trail.route_usage_modal.route_name_is_being_used_in" tag="p" class="mb-3" scope="global">
            <template #route_name><strong>{{ route.name }}</strong></template>
          </i18n-t>

          <div v-if="hikes.length === 0" class="text-muted text-center py-4">
            {{ $t('plan_trail.route_usage_modal.this_route_is_not_being_used') }}
          </div>

          <ul v-else class="list-group">
            <li v-for="hike in hikes" :key="hike.id" class="list-group-item">
              <a :href="`/hikes/${hike.slug}/edit`" target="_blank" class="text-decoration-none">
                {{ hike.name }}
                <span class="material-icons ms-2" style="font-size: 16px; vertical-align: middle;">open_in_new</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">{{ $t('shared.close') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  setup() {
    const route = ref(null);
    const hikes = ref([]);
    const isVisible = ref(false);

    function show(selectedRoute) {
      route.value = selectedRoute;
      hikes.value = selectedRoute.referencedHikes || [];
      isVisible.value = true;
    }

    function close() {
      isVisible.value = false;
    }

    return {
      route,
      hikes,
      isVisible,
      show,
      close
    };
  }
});
</script>

<style scoped>
.list-group-item a {
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.list-group-item a:hover {
  color: #0d6efd;
}
</style>
